import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    timeWindow: (start: string, end: string) =>
      translate({ id: 'global.timeWindow', values: { start, end } }),
  }))

  return api
}
